import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Le fragment est rendu par Rails : sans préfixe de langue, la route
  // retombe sur I18n.default_locale et renvoie du FRANÇAIS à un
  // utilisateur anglais, à l'intérieur d'un écran par ailleurs anglais.
  // La langue se lit dans l'URL : la balise <html> ne porte pas de `lang`.
  get locale() {
    const segment = window.location.pathname.split("/")[1];
    return ["fr", "en"].includes(segment) ? segment : "fr";
  }

  static targets = [
    "modal",
    "academicYearSelector",
    "holidaysList",
    "academicYearId",
    "editButton",
    "deleteButton",
  ];
  static values = {
    holidaysByYearPath: String,
  };

  connect() {
    console.log("Holiday Manager controller connected");
  }

  // Gestion du sélecteur d'année académique
  changeAcademicYear(event) {
    const academicYearId = event.target.value;

    fetch(
      this.holidaysByYearPathValue.replace("ACADEMIC_YEAR_ID", academicYearId),
      {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      }
    )
      .then((response) => response.text())
      .then((html) => {
        this.holidaysListTarget.innerHTML = html;

        // Mettre à jour l'ID de l'année académique dans le formulaire
        if (this.hasAcademicYearIdTarget) {
          this.academicYearIdTarget.value = academicYearId;
        }

        // Mettre à jour les attributs data-holidays-manager-academic-year-param
        document
          .querySelectorAll("[data-holidays-manager-academic-year-param]")
          .forEach((element) => {
            element.setAttribute(
              "data-holidays-manager-academic-year-param",
              academicYearId
            );
          });
      })
      .catch((error) =>
        console.error("Erreur lors du chargement des jours fériés:", error)
      );
  }

  // Gestion du modal
  openModal(event) {
    event.preventDefault();
    const academicYearId = event.currentTarget.getAttribute(
      "data-holidays-manager-academic-year-param"
    );

    if (this.hasAcademicYearIdTarget && academicYearId) {
      this.academicYearIdTarget.value = academicYearId;
    }

    this.modalTarget.classList.remove("hidden");
  }

  closeModal(event) {
    event.preventDefault();
    this.modalTarget.classList.add("hidden");
  }

  // Édition d'un jour férié
  edit(event) {
    event.preventDefault();
    const holidayId = event.currentTarget.getAttribute("data-holiday-id");

    // Récupérer les données du jour férié
    fetch(`/${this.locale}/schools/settings/holidays/${holidayId}/edit`, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Remplir le formulaire avec les données du jour férié
        document.getElementById("holiday_name").value = data.name;
        document.getElementById("holiday_start_date").value = this.formatDate(
          data.start_date
        );
        document.querySelector("#holiday_start_date + input").value = toLongDate(
          new Date(data.start_date)
        );
        document.getElementById("holiday_end_date").value = this.formatDate(
          data.end_date
        );
        document.querySelector("#holiday_end_date + input").value = toLongDate(
          new Date(data.end_date)
        );

        // Changer l'URL du formulaire pour la mise à jour
        const form = document.getElementById("holiday-form");
        form.action = `/schools/settings/holidays/${holidayId}`;
        form.insertAdjacentHTML(
          "beforeend",
          '<input type="hidden" name="_method" value="patch">'
        );

        // Changer le titre du modal
        document.getElementById("modal-title").textContent =
          "Modifier un jour férié";

        // Ouvrir le modal
        this.modalTarget.classList.remove("hidden");
      })
      .catch((error) =>
        console.error("Erreur lors de la récupération du jour férié:", error)
      );
  }

  // Formatage de date pour les champs de formulaire
  formatDate(dateString) {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  }
}
